<template>
  <div
    class="sn-bs-wrapper"
    v-loading="loading"
    element-loading-background="rgba(0, 0, 0, 0.2)"
  >
    <main v-if="certificateNum !== 0" class="sn-bs-wrapper__main">
      <div class="sn-bs-content-top">
        <div class="sn-bs-content-certificate sn-bs-content-top-info">
          <p class="sn-bs-content-top-info__p">绿色认证证书</p>
          <div class="sn-bs-content-top-info-text">
            {{ certificateNum }}
            <span class="sn-bs-content-top-info-text__span">份</span>
          </div>
        </div>
        <div class="sn-bs-content-production sn-bs-content-top-info">
          <p class="sn-bs-content-top-info__p">累计批准年产量</p>
          <div class="sn-bs-content-top-info-text">
            {{ annualOutput }}
            <span class="sn-bs-content-top-info-text__span">吨</span>
          </div>
        </div>
      </div>
      <div class="sn-bs-content-bottom">
        <el-carousel
          indicator-position="outside"
          arrow="never"
          :autoplay="false"
        >
          <el-carousel-item
            v-for="(item, index) in certificateImgList"
            :key="index"
          >
            <img
              v-for="(url, idx) in item"
              :key="idx"
              class="sn-bs-content-bottom__pic"
              @click="clickImg(item, idx)"
              :src="setImgUrl(url, 78, 103)"
              alt=""
            />
          </el-carousel-item>
        </el-carousel>
      </div>
    </main>
    <Empty v-else-if="!loading" />

    <BsPreviewPic
      :showDialog="showDialog"
      :initial-index="index"
      :imgUrlData="imgList"
      @closeDialog="showDialog = false"
    />
  </div>
</template>

<script>
import { mapState } from "vuex";
import { farm } from "@/api/request/snkd.produce";
import Empty from "@/components/bs/BsBoxPanel/Empty";
import BsPreviewPic from "@/components/bs/BsPreviewPic";
import { setImgUrl } from "@/utils";

export default {
  name: "BsFarmModule06",
  components: { Empty, BsPreviewPic },
  data() {
    return {
      loading: false,
      certificateNum: 0,
      annualOutput: 0,
      certificateImgList: [],

      showDialog: false,
      index: 0,
      imgList: [],
    };
  },
  computed: {
    ...mapState(["farmId"]),
  },
  mounted() {
    this.initModel();
  },
  methods: {
    setImgUrl,
    async initModel() {
      this.loading = true;
      try {
        const data = await farm.queryByFarmIdService({
          farmId: this.farmId,
        });
        if (!data) {
          this.loading = false;
          return false;
        }
        this.certificateNum = data.length;
        if (data.length == 1) {
          this.annualOutput = data[0].approvedAnnualOutput;
        } else {
          this.annualOutput = data.reduce((prev, cur) => {
            prev = typeof prev === "number" ? prev : prev.approvedAnnualOutput;
            return prev + cur.approvedAnnualOutput;
          });
        }

        let imgData = [];
        data.forEach((item) => {
          if (item.certificateDefaultPic !== "") {
            imgData.push(item.certificateDefaultPic);
          }
        });
        for (let i = 0, len = imgData.length; i < len; i += 4) {
          this.certificateImgList.push(imgData.slice(i, i + 4));
        }
      } catch (e) {
        console.log(e);
      }
      this.loading = false;
    },
    clickImg(data, index) {
      this.$emit("closeAll"); //触发父级事件 关闭当前页面所有弹框
      this.imgList = data;
      this.index = index;
      this.showDialog = true;
    },
  },
};
</script>

<style lang="scss" scoped>
@include bs(wrapper) {
  @include utils-full-box();
  box-sizing: border-box;

  @include e(main) {
    @include utils-scrollbar();
    @include utils-full-box();
    margin-top: 12px;
    display: flex;
    flex-direction: column;
    overflow-y: auto;

    @include bs(content-top) {
      height: 76px;
      margin-bottom: 12px;
      display: flex;
      justify-content: space-between;

      @include bs(content-top-info) {
        flex: 1;
        height: 76px;
        padding-left: 52px;
        display: flex;
        flex-direction: column;
        justify-content: center;

        @include e(p) {
          margin-bottom: 12px;
          font-size: 14px;
          font-weight: bold;
          color: #9dd1d7;
        }
        @include bs(content-top-info-text) {
          font-size: 24px;
          font-weight: bold;
          color: #feec53;

          @include e(span) {
            font-size: 18px;
          }
        }
      }

      @include bs(content-certificate) {
        margin-right: 8px;
        background: url("~@/assets/images/bs/lvserenzheng-block-bg.png")
          no-repeat center center/100% 100%;
      }
      @include bs(content-production) {
        background: url("~@/assets/images/bs/changliang-block-bg.png") no-repeat
          center center/100% 100%;
      }
    }

    @include bs(content-bottom) {
      flex: 1;

      @include e(pic) {
        width: calc(25% - 2px);
        height: 100%;
        margin-left: 4px;
        cursor: pointer;

        &:first-child {
          margin-left: 0;
        }
      }
    }
  }
}
</style>
<style lang="scss">
.sn-bs-wrapper__main {
  @include be(carousel) {
    height: 100%;
    @include meb($element: container) {
      height: calc(100% - 26px);

      @include meb($element: item) {
        box-sizing: border-box;
        padding: 8px;
        display: flex;
        //justify-content: space-between;
        background: #0a3927;
      }
    }
  }
}
</style>
